import { Model } from '@nozbe/watermelondb';
import { field } from '@nozbe/watermelondb/decorators';
import type { ProductVariant } from '../../../redux/productSlice';

function parseJsonArray<T>(value: string | undefined | null, fallback: T[]): T[] {
  if (!value) {
    return fallback;
  }
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : fallback;
  } catch {
    return fallback;
  }
}

export default class DemoProduct extends Model {
  static table = 'demo_products';

  @field('bp_owner_id') bpOwnerId!: string;
  @field('bp_product_location_id') bpProductLocationId!: string;
  @field('bp_product_barcode') bpProductBarcode!: string;
  @field('bp_product_name') bpProductName!: string;
  @field('bp_product_category') bpProductCategory!: string;
  @field('bp_product_sub_category') bpProductSubCategory!: string;
  @field('bp_product_price_type') bpProductPriceType!: string;
  @field('bp_product_unit_of_mass') bpProductUnitOfMass!: string;
  @field('bp_product_mass') bpProductMass!: string;
  @field('bp_product_buying_price') bpProductBuyingPrice!: number;
  @field('bp_product_selling_price') bpProductSellingPrice!: number;
  @field('bp_product_quantity') bpProductQuantity!: number;
  @field('bp_product_size') bpProductSize!: string;
  @field('bp_minimum_stock_level') bpMinimumStockLevel!: number;
  @field('bp_product_model') bpProductModel!: string;
  @field('bp_product_image') bpProductImage!: string;
  @field('bp_product_deleted') bpProductDeleted!: boolean;
  @field('bp_product_is_favourite') bpProductIsFavourite!: boolean;
  @field('bp_product_created_at') bpProductCreatedAt!: number;
  @field('bp_product_updated_at') bpProductUpdatedAt!: number;
  @field('bp_product_has_variants') bpProductHasVariants!: boolean;
  @field('bp_product_variant_attributes') bpProductVariantAttributes!: string;
  @field('bp_product_variants') bpProductVariants!: string;

  getVariantAttributes(): string[] {
    return parseJsonArray<string>(this.bpProductVariantAttributes, []);
  }

  getVariants(): ProductVariant[] {
    return parseJsonArray<ProductVariant>(this.bpProductVariants, []);
  }

  // Helper to convert to plain object matching existing UI field names
  toProductObject() {
    return {
      _id: this.id,
      bp_owner_id: this.bpOwnerId,
      bp_product_location_id: this.bpProductLocationId,
      bp_product_barcode: this.bpProductBarcode,
      bp_product_name: this.bpProductName,
      bp_product_category: this.bpProductCategory,
      bp_product_sub_category: this.bpProductSubCategory,
      bp_product_price_type: this.bpProductPriceType,
      bp_product_unit_of_mass: this.bpProductUnitOfMass,
      bp_product_mass: this.bpProductMass,
      bp_product_buying_price: this.bpProductBuyingPrice,
      bp_product_selling_price: this.bpProductSellingPrice,
      bp_product_quantity: this.bpProductQuantity,
      bp_product_size: this.bpProductSize,
      bp_minimum_stock_level: this.bpMinimumStockLevel,
      bp_product_model: this.bpProductModel,
      bp_product_image: this.bpProductImage,
      bp_product_deleted: this.bpProductDeleted,
      bp_product_is_favourite: this.bpProductIsFavourite,
      bp_product_created_at: this.bpProductCreatedAt,
      bp_product_updated_at: this.bpProductUpdatedAt,
      bp_product_has_variants: Boolean(this.bpProductHasVariants),
      bp_product_variant_attributes: this.getVariantAttributes(),
      bp_product_variants: this.getVariants(),
    };
  }
}
